import React from 'react';
import { connect } from 'react-redux';

import { openComponent, closeComponent } from 'actions';

class DropDownX extends React.Component {
    constructor(props) {
        super(props);
        this._onButtonClick = this._onButtonClick.bind(this);
        this._onMenuItemClick = this._onMenuItemClick.bind(this);
        this._getItem = this._getItem.bind(this);
    }

    _onButtonClick(event) {
        event.stopPropagation();
        const { componentOpen, openComponent, closeComponent } = this.props;
        if (componentOpen === this) {
            closeComponent();
        } else {
            openComponent(this);
        }
    }

    _onMenuItemClick(item, event) {
        event.stopPropagation();
        const { data, closeComponent } = this.props;
        const { onChange, id } = data;
        onChange && onChange(id, item.value);
        closeComponent();
    }

    _getItem(value) {
        if (value !== undefined) {
            const { items } = this.props.data;
            for (const i in items) {
                if (items[i].value == value) {
                    // eslint-disable-line eqeqeq
                    return items[i];
                }
            }
        }
        return undefined;
    }

    render() {
        const { data, value, loading, componentOpen } = this.props;
        const open = componentOpen === this;
        const item = this._getItem(value);
        let current;
        let text = data.initialText;
        let defaultItem = true;
        if (item) {
            current = item.value;
            text = item.text;
            defaultItem = item.defaultItem;
        }
        let buttonClassName = 'cc-dropdown-button';
        if (open) {
            buttonClassName += ' cc-dropdown-open';
        }
        if (!defaultItem) {
            buttonClassName += ' cc-dropdown-non-default';
        }
        let buttonIcon;
        let rightIcon;
        if (loading) {
            buttonClassName += ' loading';
            buttonIcon = 'sync';
            rightIcon = 'sync';
        } else {
            buttonIcon = data.icon;
            rightIcon = open ? 'arrow_drop_up' : 'arrow_drop_down';
        }
        return (
            <div className="cc-dropdown">
                <div className={buttonClassName} onClick={this._onButtonClick}>
                    <i className="cc-navbar-item-icon material-icons">{buttonIcon}</i>
                    <span className="cc-dropdown-item-text">{text}</span>
                    <i className="cc-dropdown-arrow material-icons">{rightIcon}</i>
                </div>
                <DropDownMenu data={data} open={open} current={current} onClick={this._onMenuItemClick} />
            </div>
        );
    }
}

const DropDown = connect(
    state => ({
        componentOpen: state.componentOpen
    }),
    {
        openComponent,
        closeComponent
    }
)(DropDownX);

export default DropDown;

const DropDownMenu = ({ data, open, current, onClick }) => {
    let className = 'cc-dropdown-menu';
    if (open) {
        className += ' cc-dropdown-menu-slidedown';
    }
    return (
        <div className={className}>
            <ul>
                {data.items.map((item, index) => {
                    if (item.seperator) {
                        return <li key={index} className="cc-separator" />;
                    }
                    return <DropDownMenuItem key={index} item={item} current={current} onClick={onClick} />;
                })}
            </ul>
        </div>
    );
};

const DropDownMenuItem = ({ item, current, onClick }) => {
    let className;
    if (item.defaultItem) {
        className = 'cc-dropdown-default';
    }
    if (current) {
        if (item.value === current) {
            className += ' cc-dropdown-current';
        }
    } else if (item.defaultItem) {
        className += ' cc-dropdown-current';
    }
    return (
        <li className={className} onClick={onClick.bind(null, item)}>
            <i className="cc-dropdown-item-icon material-icons">check</i>
            {item.text}
        </li>
    );
};



// WEBPACK FOOTER //
// ./src/components/DropDown.jsx